'use client';

import { usePostHog } from 'posthog-js/react';
import { useEffect, Suspense } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { Auth } from '~/modules/auth/client';
import { wrapComponent } from '~/utils/react';
import { _POSTHOG_SHARED_CONFIG } from './shared';

export const Action_PostHog_TrackGlobals = wrapComponent(() => {
    const posthog = usePostHog();

    // Track page view
    {
        const pathname = usePathname();
        const searchParams = useSearchParams();

        // Track pageviews
        useEffect(() => {
            if (!pathname || !searchParams) return; // Should never happen because we use app dir
            if (!posthog) return; // TODO: check if this should ever happen

            const url = new URL(window.origin);
            url.pathname = pathname;
            url.search = searchParams?.toString() || '';

            posthog.capture('$pageview', { $current_url: url.toString() });
        }, [pathname, searchParams, posthog]);
    }

    const auth = Auth.useSession();
    useEffect(() => {
        if (!auth.user || !posthog) return;
        posthog.identify(auth.user.email);
    }, [auth, posthog]);

    return null;
}, Suspense);
